'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildHostname = buildHostname;
exports.hostname = hostname;
exports.tld = tld;

var _lzdmodCommonInfo = require('@ali/lzdmod-common-info');

/**
 * build hostname with subDomain
 * Only support second level domain
 * @param {string} hostname
 * @param {string} subDomain
 */

function buildHostname(hostName, subDomain) {
  var parts = hostName.split('.');
  parts[0] = subDomain;
  return parts.join('.');
}

function hostname(subDomain) {
  return buildHostname(window.location.hostname, subDomain);
}

function tld() {
  if (typeof window !== 'undefined') {
    var project = (0, _lzdmodCommonInfo.projectDetection)();
    var firstDomain = '.lazada.';
    if (project.isYatra) {
      if (project.venture === 'MM') {
        firstDomain = '.shop.';
      } else {
        firstDomain = '.daraz.';
      }
    } else if (project.isVoyager) {
      firstDomain = '.lazada.';
    }
    var hostName = window.location.hostname;
    var suffix = hostName.split(firstDomain);
    if (suffix && suffix.length && suffix[1]) {
      return suffix[1];
    }
  }
  return 'sg';
}


// WEBPACK FOOTER //
// ./node_modules/_@ali_lzdmod-axios@2.1.2@@ali/lzdmod-axios/lib/util.js